import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import {
  employee,
  recommendedVideo,
  profileCompletion,
  manageSkills,
  careerPreferences,
  workHistory,
  education,
  successProfileTopCategories,
  markedAsReadFields,
  manageCompetencies,
  successProfile,
  onboardEmployeeSkills,
  onboardEmployeeRoles,
  onboardEmployeeOpenToWork,
} from 'modules/profile/stateManagement/reducer';
import {
  graphAPIConfigReducer,
  auth,
} from 'modules/auth/stateManagement/reducer';
import { popupNotifications } from 'modules/popupNotification/stateManagement/reducer';
import IStoreState from './IStoreState';
import {
  notificationsFromStore,
  signalRConnection,
  systemMaintenance,
  rbac,
} from 'shared/stateManagement/reducer';
import {
  myOpenRoles,
  selectedOpenRequisition,
} from 'modules/hiring/stateManagement/reducer';


export const reducers = combineReducers<IStoreState>({
  employee,
  profileCompletion,
  recommendedVideo,
  auth,
  graphAPIConfigReducer,
  careerPreferences,
  popupNotifications,
  manageSkills,
  workHistory,
  education,
  successProfileTopCategories,
  markedAsReadFields,
  manageCompetencies,
  successProfile,
  onboardEmployeeSkills,
  onboardEmployeeRoles,
  onboardEmployeeOpenToWork,
  signalRConnection,
  notificationsFromStore,
  systemMaintenance,
  rbac,
  myOpenRoles,
  selectedOpenRequisition,
});

export default createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunk))
);
